module.exports = "/fonts/vendor/lightgallery/src/lg.ttf?f4292655f93dd12d9b8e4fc067ef2489";